@import '../../../../themes/site/default/assets/common_helpers_non_liquid.scss';
@import '../../../../themes/site/default/assets/responsive_helpers.scss';

.clp_theme_config.clp_theme {
  &.section--clp_testimonials {
    .testimonials--container {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      padding: 60px 0;
    }

    .testimonials--wrapper {
      .testimonials--item-wrapper {
        margin-bottom: 96px;

        .clp_review {
          background: white;
          margin: 0 20px;
          border-radius: 10px;
        }
      }
    }

    .content--container {
      margin-bottom: 40px;
    }

    .testimonials--enroll-button {
      display: flex;
      justify-content: center;
      margin-bottom: 96px;
    }

    .splide__arrows.clp_testimonials-arrows {
      .clp_testimonials-arrow {
        bottom: -4.5rem;
        top: unset;
        height: 48px;
        width: 48px;
        display: inline-table;
        opacity: 1;

        svg {
          path {
            fill: var(--color-primary);
          }
        }
      }

      .clp_testimonials-next {
        right: calc(50% - 50px);
      }

      .clp_testimonials-prev {
        left: calc(50% - 50px);
      }
    }

    &.section--default {
      .testimonials--item-wrapper .clp_review,
      .clp_testimonials-arrows .clp_testimonials-arrow {
        background: var(--color-body-most-contrasted-neutral-10-white);
      }
    }

    &.section--alternate {
      .testimonials--item-wrapper .clp_review,
      .clp_testimonials-arrows .clp_testimonials-arrow {
        background: var(
          --color-body-alternate-most-contrasted-neutral-10-white
        );
      }

      .clp_testimonials-arrows .clp_testimonials-arrow {
        svg {
          path {
            fill: var(--color-secondary);
          }
        }
      }
    }

    .clp_testimonials-pagination {
      display: none;
    }

    @include below-desktop {
      .content--container {
        margin-bottom: 48px;
      }
      .testimonials--item-wrapper {
        margin-bottom: 48px !important;
      }
    }

    .testimonials--wrapper.icon-style-outline {
      .splide__arrow {
        background-color: transparent;
        border: 1px solid black;
        svg {
          path {
            fill: black;
          }
          margin-top: -8px;
          width: 40px;
          height: 40px;
        }
        &.clp_testimonials-next {
          right: calc(50% - 60px);
          margin-left: 5px;
          svg {
            margin-right: 8px;
          }
        }
        &.clp_testimonials-prev {
          left: calc(50% - 60px);

          svg {
            margin-left: 8px;
          }
        }
      }
    }
  }
}
